import {
	getAvailablePaymentTerms,
	getPartnerDepositPercentage,
} from "app/reducers/partnerSelector";
import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";
import { connect } from "react-redux";
import PaymentDescriptionTerms from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTerms";
import { isDepositEnabled } from "app/pages/.shared/Deposit/depositSelector";
import { isBookingDateEligibleForDeposit } from "app/pages/Booking/bookingSelectors";
import { useShowDepositFlag } from "app/pages/.shared/Deposit/useShowDepositFlag";
import PropTypes from "prop-types";

// AB Test : si le flag deposit est inactif (variation B),
// on force enableDepositDisplay à false pour afficher les termes de paiement classiques (2x, 4x)
// au lieu de la version deposit (acompte %).
const PaymentDescriptionTermsContainer = props => {
	const showDepositFlagValue = useShowDepositFlag();

	return (
		<PaymentDescriptionTerms
			{...props}
			enableDepositDisplay={showDepositFlagValue ? props.enableDepositDisplay : false}
		/>
	);
};

const mapStateToProps = state => {
	return {
		availablePaymentTerms: getAvailablePaymentTerms(state),
		availablePaymentMethods: getAvailablePaymentMethods(state),
		enableDepositDisplay: isDepositEnabled(state),
		isBookingDateEligibleForDeposit: isBookingDateEligibleForDeposit(state),
		onlinePercentage: getPartnerDepositPercentage(state),
	};
};

PaymentDescriptionTermsContainer.propTypes = {
	enableDepositDisplay: PropTypes.bool,
};

export default connect(mapStateToProps)(PaymentDescriptionTermsContainer);
